import * as React from 'react';
import { connect } from 'react-redux';

import BooksMenuItem from '../../../../components/books/model1/BooksMenuItem';
import { Lesson } from '../../../../interfaces/merchants/resources/books';

interface Props {
  lessons: Lesson[];
  postable: boolean;
  onClick: (lesson: Lesson) => void;
}

class InputBookingTargetLessonSelector extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.handleClickLesson = this.handleClickLesson.bind(this);
  }

  public handleClickLesson(e: React.MouseEvent<HTMLInputElement>) {
    const { lessons, onClick } = this.props;
    const lesson = lessons.find(l => String(l.id) === e.currentTarget.value)!;
    onClick(lesson);
  }

  public render() {
    const { lessons, postable } = this.props;

    return (
      <div>
        {lessons.map(lesson => (
          <BooksMenuItem
            key={lesson.id}
            courseName={lesson.name}
            postable={postable}
            onClick={this.handleClickLesson}
            text={lesson.description}
            value={lesson.id}
          />
        ))}
      </div>
    );
  }
}

export default connect()(InputBookingTargetLessonSelector);
